import { Button } from '@mui/material';
import React from 'react';
import { sharedColors } from 'ui/theme/colors';

type SubmitButtonProps = {
    children: React.ReactNode;
};
const SubmitButton: React.FC<SubmitButtonProps> = ({ children }) => {
    return (

        <Button
            type="submit"
            sx={{
                width: "100%",
                backgroundColor: sharedColors.blue,
                color: "#fff",
                borderRadius: "24px",
                display: "flex",
                justifyContent: "center",
                gap: "12px",
                padding: "9px 0",
                fontSize: "20px",
                lineHeight: "28px",
                marginBottom: "40px",
                transition: "none",
                "&:hover": {
                    backgroundColor: sharedColors.blue, // Example hover style
                },
                "@media (min-width: 768px)": {
                    width: "120px",
                    marginBottom: "0",
                },
                "@media (min-width: 1200px)": {
                    width: "91px",
                    padding: "4px 14px 4px 23px"
                },
                "@media (min-width: 1450px)": {
                    width: "156px",
                },
            }}
        >
            {children}
        </Button>
    );
};
export default SubmitButton;
